module.exports = {"dashboard":"পানেল","dashboardItems":{"versionOne":"সংস্করণ এক","versionTwo":"দ্বিতীয় সংস্করণ","versionThree":"সংস্করণ তিন","versionFour":"সংস্করণ চার"}}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/lang/i18n/bn.json
// module id = OeEZ
// module chunks = 35